import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { PrimeBroker, EntityType } from 'api'
import { PrimeBrokerHelper } from 'model'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { createPrimeBrokersByOrganisationSelector } from 'selectors/organisationSelectors'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { Field } from 'view/components/inputs'

export interface PrimeBrokerSelectboxProps extends SelectboxProps<PrimeBroker, string> {
  organisationId?: string | null
}

const organisationIdSelector = (_: {}, props: PrimeBrokerSelectboxProps) => props.organisationId

const primeBrokerMapStateToProps = createStructuredSelector({
  optionKeys: createPrimeBrokersByOrganisationSelector(organisationIdSelector),
  getOption: createEntityGetterSelector(EntityType.PRIME_BROKER)
})

export const PrimeBrokerSelectbox = connect(primeBrokerMapStateToProps, null, null, { forwardRef: true })(Selectbox) as React.ComponentType<
  Omit<PrimeBrokerSelectboxProps, 'optionKeys' | 'getOption'>
>

PrimeBrokerSelectbox.defaultProps = {
  getOptionText: PrimeBrokerHelper.getName,
  canClear: true
}

export const PrimeBrokerSelectboxField = Field(PrimeBrokerSelectbox)
